export class Instruction {
  constructor ({ name, waitForNoLoaders, type, scope }) {
    this.id = undefined
    this.type = type
    this.name = name
    this.waitForNoLoaders = waitForNoLoaders
    this.scope = scope
  }

  getParsedInstruction () {
    return {
      id: this.id,
      type: this.type,
      name: this.name,
      waitForNoLoaders: this.waitForNoLoaders,
      scope: this.scope
    }
  }
}
